<template>
  <div class="spinner__wrapper">
    <div class="spinner">
      <div class="one"></div>
      <div class="two"></div>
      <div class="three"></div>
    </div>
    <div class="text">{{ $t(text) }}</div>
  </div>
</template>

<script>
export default {
  name: 'BaseSpinner',
  props: {
    text: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.spinner__wrapper {
  width: 8rem;
  display: block;

  .spinner {
    width: 100%;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .text {
    text-align: center;
    font-size: 1.2rem;
    font-weight: 500;
    color: $company-color;
  }

  .one,
  .two,
  .three {
    width: 1.8rem;
    height: 1.8rem;
    border-radius: 100%;
    background-color: $company-color;
    animation: bouncedelay 1.4s infinite ease-in-out both;
  }

  .one {
    animation-delay: -0.32s;
  }

  .two {
    animation-delay: -0.16s;
  }

  @keyframes bouncedelay {
    0%,
    80%,
    100% {
      transform: scale(0);
    }

    40% {
      transform: scale(1);
    }
  }
}
</style>